import { useMemo } from "react"
import { useAsyncSelector } from "src/hooks/useAsyncSelector"
import { memberInvitationSelectorFamily } from "src/recoil/selectors/organization/memberInvitationSelectorFamily"
import { useResource } from "src/recoil/hooks/resource/useResource"

export const useEmailInvitationResultData = (id: string) => {
  const { value: emailInvitationResultData, isLoading: isEmailInvitationResultDataLoading } = useAsyncSelector(
    memberInvitationSelectorFamily(id)
  )
  const { resourceUrl: thumbnailImageUrl } = useResource({ type: "teamImage", id, size: "thumbnail" })
  const organizationName = useMemo(() => emailInvitationResultData?.organizationName, [emailInvitationResultData])

  return {
    thumbnailImageUrl,
    organizationName,
    isEmailInvitationResultDataLoading,
  }
}
